// extracted by mini-css-extract-plugin
export default {"upload-box":"upload_box_upload-box__w9PXB","mobile-text-div":"upload_box_mobile-text-div__9KVjD"};